module.exports = __webpack_public_path__ + "static/plano-de-saude-5a3f9c9de364a6696829415ee84cd955.png";